import planning from './planning/zh'

export default {
  nav: {
    dashboard: '仪表板',
    projects: '项目',
    maps: '地图',
    data: '数据',
    analytics: '分析',
    settings: '设置',
    profile: '个人资料',
    team: '团队',
    billing: '账单',
    apiKeys: 'API密钥',
  },
  dashboard: {
    title: '仪表板',
    overview: '概览',
    recentActivity: '最近活动',
    quickStats: '快速统计',
    totalProjects: '总项目数',
    totalMaps: '总地图数',
    totalUsers: '总用户数',
    storageUsed: '已使用存储',
  },
  projects: {
    title: '项目',
    createProject: '创建项目',
    myProjects: '我的项目',
    sharedProjects: '共享项目',
    archivedProjects: '已归档项目',
    projectName: '项目名称',
    description: '描述',
    createdAt: '创建时间',
    updatedAt: '最后更新',
    owner: '所有者',
    members: '成员',
    noProjects: '未找到项目',
    deleteProject: '删除项目',
    archiveProject: '归档项目',
    restoreProject: '恢复项目',
  },
  maps: {
    title: '地图',
    createMap: '创建地图',
    myMaps: '我的地图',
    sharedMaps: '共享地图',
    mapName: '地图名称',
    mapType: '地图类型',
    layers: '图层',
    addLayer: '添加图层',
    removeLayer: '移除图层',
    exportMap: '导出地图',
    shareMap: '分享地图',
  },
  data: {
    title: '数据',
    uploadData: '上传数据',
    importData: '导入数据',
    exportData: '导出数据',
    dataSource: '数据源',
    dataSources: '数据源',
    dataset: '数据集',
    datasets: '数据集',
    records: '记录',
    columns: '列',
    preview: '预览',
  },
  analytics: {
    title: '分析',
    reports: '报告',
    createReport: '创建报告',
    viewReport: '查看报告',
    exportReport: '导出报告',
    spatialAnalysis: '空间分析',
    statistics: '统计',
    trends: '趋势',
    insights: '洞察',
  },
  settings: {
    title: '设置',
    general: '常规',
    account: '账户',
    security: '安全',
    notifications: '通知',
    preferences: '偏好',
    language: '语言',
    timezone: '时区',
    appearance: '外观',
    theme: '主题',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    systemDefault: '系统默认',
  },
  team: {
    title: '团队',
    inviteMember: '邀请成员',
    members: '成员',
    pending: '待处理邀请',
    role: '角色',
    admin: '管理员',
    member: '成员',
    viewer: '查看者',
    removeMember: '移除成员',
    changeRole: '更改角色',
  },
  billing: {
    title: '账单与订阅',
    subtitle: '管理您的订阅、信用余额和席位。',
    loading: '正在加载订阅…',
    nav: '账单与订阅',
    currentPlan: '当前方案',
    usage: '使用情况',
    invoices: '发票',
    paymentMethod: '支付方式',
    updatePayment: '更新支付方式',
    upgradePlan: '升级方案',
    downgradePlan: '降级方案',
    cancelSubscription: '取消订阅',
    subscription: {
      title: '订阅',
      cadence: '账单周期',
      seats: '席位',
      seatsBreakdown: '{{admin}} 管理员 · {{publisher}} 发布者 · {{viewer}} 查看者',
      periodEnd: '当前周期结束于',
      trialEnd: '试用结束于',
      cancelAtPeriodEnd: '此订阅将在当前周期结束时取消。',
      endedOn: '您的订阅已于 {{date}} 结束。',
    },
    cancel: {
      button: '取消订阅',
      confirmTitle: '取消订阅？',
      confirmBody: '您的订阅在 {{date}} 之前仍然有效，之后将取消。在此之前您将保留完整访问权限。',
      confirmCta: '取消订阅',
      keep: '保留订阅',
      reasonLabel: '您为什么要取消？（可选）',
      notePlaceholder: '还有其他事项吗？（可选）',
      success: '您的订阅将在周期结束时取消。',
      reasons: {
        too_expensive: '太贵了',
        missing_features: '缺少功能',
        switching: '转用其他产品',
        no_longer_needed: '不再需要',
        other: '其他',
      },
    },
    reactivate: {
      button: '重新激活订阅',
      success: '您的订阅已重新激活。',
    },
    balance: {
      title: '信用余额',
      credits: '信用点',
      reserved: '已预留 {{count}}',
    },
    seats: {
      title: '席位',
      save: '保存席位',
      admin: '管理员',
      publisher: '发布者',
      viewer: '查看者',
    },
    topup: {
      title: '充值信用点',
      blockCount: '区块',
      blockHelper: '= {{credits}} 信用点',
      buy: '充值',
      charged: '信用点已成功添加。',
    },
    portal: {
      button: '管理账单',
    },
    empty: {
      title: '没有有效的订阅',
      body: '您的组织尚未拥有有效的订阅。',
    },
    outOfCredits: {
      title: '信用点不足',
      body: '此操作所需的信用点超过您的组织当前可用的数量。',
      shortfall: '差额',
      balance: '当前余额',
      askAdmin: '请联系您的组织管理员充值信用点。',
      dismiss: '关闭',
      topUp: '充值',
    },
  },
  signup: {
    title: '创建你的工作区',
    subtitle: '开启你的 14 天免费试用。',
    orgName: '组织名称',
    subdomain: '工作区地址',
    email: '管理员邮箱',
    seats: '席位',
    seatsAdmin: '管理员',
    seatsPublisher: '发布者',
    seatsViewer: '查看者',
    planSummary: '按席位计划 · {{cadence}}',
    cadenceMonthly: '按月',
    cadenceAnnual: '按年',
    submit: '前往结账',
    submitting: '正在前往结账…',
    haveAccount: '已经有账户了？',
    signIn: '登录',
    available: '可用',
    checking: '检查中…',
    errors: {
      subdomainFormat: '请使用小写字母、数字和连字符（3–63 个字符）',
      subdomainReserved: '该地址已被保留——请另选一个',
      subdomainTaken: '该地址不可用——请另选一个',
      emailTaken: '该邮箱无法用于新注册',
      startFailed: '无法前往结账。请重试。',
    },
    success: {
      provisioning: '正在设置你的工作区…',
      provisioningHint: '这通常不到一分钟。',
      readyTitle: '你的工作区已就绪',
      readyBody: '我们已向 {{email}} 发送登录邀请。打开它以设置你的密码。',
      goToLogin: '前往登录',
      failedTitle: '出了点问题',
      failedBody: '我们无法完成你的工作区设置。请联系支持团队。',
      timeoutBody: '仍在收尾——请查看你的邮箱以获取邀请，然后登录。',
    },
  },
  groups: {
    title: '群组',
    subtitle: '管理用户群组和共享',
    create: '创建群组',
    name: '名称',
    description: '描述',
    members: '成员',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    deleteGroup: '删除群组',
    deleteConfirm: '删除此群组？与其共享的资源将不再对其成员开放。',
    save: '保存',
    cancel: '取消',
    noGroupsTitle: '暂无群组',
    noGroupsBody: '创建群组后，可通过任意地图、仪表板或图层上的“共享”按钮与其共享资源。',
    addMember: '按姓名或邮箱搜索用户...',
    removeMember: '移除成员',
    nameRequired: '名称为必填项',
    myGroupsTitle: '我的群组',
    myGroupsHelp: '你所属的群组。请联系管理员以加入或退出群组。',
    myGroupsEmpty: '你还不是任何群组的成员。',
  },
  forms: {
    title: '表单',
    subtitle: '构建可将数据直接收集到图层中的表单',
    newForm: '新建表单',
    empty: '暂无表单',
    emptyBody: '创建您的第一个表单，开始收集外业数据。',
    create: '创建表单',
    creating: '创建中…',
    statusDraft: '草稿',
    statusPublished: '已发布',
    statusArchived: '已归档',
    archive: '归档',
    archiveConfirm: '归档此表单？',
    archiving: '归档中…',
    unarchive: '取消归档',
    filterActive: '使用中',
    filterArchived: '已归档',
    searchPlaceholder: '搜索表单',
    sortLabel: '排序',
    sortUpdated: '最近更新',
    sortName: '名称',
    sortStatus: '状态',
    noMatchTitle: '没有匹配的表单',
    noMatchBody: '请尝试其他搜索。',
    meta: {
      updated: '更新于 {{time}}',
      fieldCount_one: '{{count}} 个字段',
      fieldCount_other: '{{count}} 个字段',
      targetNew: '新建图层',
      targetExisting: '现有图层',
    },
    loadError: '加载表单失败',
    actionError: '操作失败',
    archivedEmptyTitle: '没有已归档的表单',
    archivedEmptyBody: '您归档的表单将显示在此处。',
    nameLabel: '标题',
    edit: '编辑',
    common: {
      yes: '是',
      no: '否',
    },
    submissions: {
      openOnMap: '在地图上打开',
      targetReplaced: '地图行已被替换',
      targetReplacedHint: '此回复保存后，图层数据已被替换，因此它在地图上的行已不存在。回复本身仍会保留。',
      backToForms: '返回表单',
      title: '提交记录',
      viewResponses: '回复',
      subtitle: '此表单收集的回复',
      empty: '尚无提交记录',
      emptyBody: '当有人开始填写此表单后，回复将显示在此处。',
      loadError: '无法加载提交记录',
      loadMore: '加载更多',
      count_one: '{{count}} 条回复',
      count_other: '{{count}} 条回复',
      filterStatus: '状态',
      filterAll: '全部',
      noMatch: '没有符合此筛选条件的提交。',
      anonymous: '匿名',
      unknownUser: '未知用户',
      deletedUser: '（已删除）',
      view: '查看',
      delete: '删除',
      retry: '重试',
      col: {
        submitted: '提交时间',
        by: '提交者',
        featureId: '要素 ID',
        action: '操作',
        status: '状态',
        actions: '操作',
      },
      action: {
        create: '已创建',
        update: '已编辑',
        delete: '已删除',
      },
      statusLabel: {
        committed: '已提交',
        pending: '待处理',
        failed: '失败',
        orphaned: '孤立',
      },
      detail: {
        title: '提交记录',
        close: '关闭',
        fields: '字段',
        geometry: '几何',
        noGeometry: '无几何',
        rawPayload: '原始数据',
        download: '下载',
        noFile: '无文件',
        targetError: '未保存到图层的原因',
      },
      deleteConfirm: {
        title: '删除此提交记录？',
        body: '这也会从目标图层中移除该要素。此操作无法撤销。',
        bodyReplaced:
          '这只会删除此回复。替换图层数据时，它的地图行已被替换，因此地图上不会有任何变化。此操作无法撤销。',
        confirm: '删除',
        cancel: '取消',
        error: '无法删除提交记录',
      },
      retryDialog: {
        title: '重新保存此回复？',
        bodyRejected: '提交时图层拒绝了此回复。其已保存的答案将再次写入图层，并按表单当前的字段进行检查。',
        warningUnknown:
          '此回复可能已在图层中：之前的尝试从未确认是否已保存。重试可能会创建重复的要素，且重复要素无法被自动找到并删除。请先检查图层。',
        confirm: '重试',
        confirmAnyway: '仍然重试',
        cancel: '取消',
        error: '无法重试此回复',
        definitionChanged: '自此回复提交以来表单已更改，其已保存的答案不再通过检查：',
        definitionChangedHint: '请修改表单使这些答案符合要求，或删除此回复。',
        attachmentMissing: '此回复上传的照片或文件已不再保存，因此无法再次写入。',
        refusedAgain: '图层再次拒绝了此回复。打开该回复查看原因。',
        outcomeUnknown: '此回复之前的尝试已无法确认是否成功。重试前请阅读警告。',
      },
      retryNotice: {
        committed: '回复已保存到图层。',
        pending: '图层未确认写入，可能已经保存：再次重试前请先检查图层。',
      },
      edit: {
        title: '编辑提交记录',
        loading: '正在加载当前要素…',
        loadError: '无法加载当前要素',
        cancel: '取消',
        retry: '重试',
        conflictTitle: '此提交记录已更改',
        conflictBody: '在您打开后，其他人已编辑此要素。请重新加载以获取最新内容，然后重新应用您的更改。',
        reload: '重新加载',
        save: '保存更改',
        saving: '保存中…',
      },
    },
    builder: {
      backToForms: '表单',
      changedElsewhere: '此表单已在别处被更改。您尚未保存的编辑已保留；重新加载即可查看其他更改。',
      reload: '重新加载',
      reloadConfirm: '放弃未保存的编辑并加载已更改的表单？',
      save: '保存',
      saving: '保存中…',
      saved: '已保存',
      loadError: '加载表单失败',
      tabEdit: '编辑',
      tabPreview: '预览',
      panePalette: '字段',
      paneCanvas: '表单',
      paneSettings: '设置',
      blockingBanner: '请修复 {{count}} 个问题后再保存',
      emptyCanvas: '从字段面板添加字段以开始构建',
      previewSubmit: '提交（仅预览）',
      addField: '添加字段',
      deleteField: '删除字段',
      moveFieldUp: '将 {{label}} 上移',
      moveFieldDown: '将 {{label}} 下移',
      fieldMoved: '{{label}} 已移至第 {{position}} / {{total}} 位',
      nameRequired: '请先为表单填写标题，再保存或发布',
      saveFailed: '您的更改未保存。您的编辑内容仍保留在此。',
      saveFailedNotPublished: '您的更改未保存，因此表单未发布。您的编辑内容仍保留在此。',
      saveErrorGeneric: '服务器未说明原因。请检查网络连接后重试。',
      columnsAdded_one: '已向图层添加 {{count}} 列',
      columnsAdded_other: '已向图层添加 {{count}} 列',
    },
    palette: {
      heading: '字段',
      text: '短文本',
      textarea: '长文本',
      integer: '整数',
      decimal: '小数',
      boolean: '是 / 否',
      date: '日期',
      selectOne: '单选',
      selectMultiple: '多选',
      photo: '照片',
      file: '文件',
      location: '位置',
    },
    config: {
      heading: '字段设置',
      label: '标签',
      autoLabel: '使用自动生成的标签：«{{label}}»',
      autoLabelTag: '自动',
      name: '字段名称',
      nameHint: '小写字母、数字和下划线；必须以字母开头',
      lockedAfterPublish: '发布后已锁定',
      reservedColumnName: '图层自身已使用“{{name}}”作为列名。请为此字段另取一个名称。',
      required: '必填',
      booleanAlwaysAnswered: '是 / 否字段始终有答案：未操作时视为“否”。',
      helpText: '帮助文本',
      placeholder: '占位符',
      defaultValue: '默认值',
      geometryType: '几何类型',
      geometryPoint: '点',
      geometryLine: '线',
      geometryPolygon: '面',
      geometryLockedTo: '锁定为目标图层（{{geometry}}）',
      mapsToColumn: '映射到列',
      mapsToColumnPlaceholder: '选择一列…',
      mapsToColumnHint: '此字段写入的目标图层列。',
      mapsToColumnLoading: '正在加载列…',
      mapsToColumnError: '无法加载图层架构。',
      mapsToColumnNone: '目标图层上没有与此字段类型兼容的列。',
      notNull: '非空',
      options: '选项',
      addOption: '添加选项',
      optionValue: '值',
      optionLabel: '标签',
      validationHeading: '验证',
      min: '最小值',
      max: '最大值',
      minLength: '最小长度',
      maxLength: '最大长度',
      pattern: '模式（正则）',
      logicHeading: '条件逻辑',
      addRule: '添加规则',
      ruleAction: '操作',
      actionShow: '显示此字段',
      actionHide: '隐藏此字段',
      actionRequire: '设为必填',
      ruleMatch: '当',
      matchAll: '全部满足',
      matchAny: '任意满足',
      addCondition: '添加条件',
      conditionField: '字段',
      conditionOp: '条件',
      conditionValue: '值',
      removeOption: '删除选项',
      removeRule: '删除规则',
      removeCondition: '删除条件',
      pickValue: '选择一个值…',
      neverMatches: {
        boolean: '此值永远不会匹配。请选择“是”或“否”。',
        option: '此值永远不会匹配。请选择其中一个选项。',
        number: '此值永远不会匹配。请输入数字。',
        date: '此值永远不会匹配。请选择日期。',
      },
      ruleMalformed: '此规则格式有误，可能不会按显示的方式生效。请编辑或删除它。',
      rulesMalformed: '此字段的规则格式有误，已被忽略。添加规则将替换它们。',
    },
    settings: {
      heading: '表单设置',
      name: '标题',
      description: '描述',
      sharingOwner: '仅自己',
      sharingOrganization: '我的组织',
      sharingGroups: '特定群组',
      sharingPublic: '公开',
    },
    op: {
      eq: '等于',
      neq: '不等于',
      gt: '大于',
      lt: '小于',
      gte: '至少',
      lte: '至多',
      contains: '包含',
      empty: '为空',
      not_empty: '不为空',
    },
    fill: {
      submit: '提交',
      submitting: '提交中…',
      loading: '加载中…',
      loadError: '此表单不可用。',
      requiredLegend: '表示必填字段',
      successTitle: '感谢您',
      successDefault: '您的回复已记录。',
      submitAnother: '再次提交',
      anonymousNotice: '您无需登录即可提交此表单。',
      submittingAs: '以 {{name}} 的身份提交',
      poweredBy: '由 Gisify 提供支持',
      privacyNote: '您的回复将发送给表单所有者。',
      networkError: '无法提交 — 请检查网络连接后重试。',
      submitFailed: '无法保存您的回复。请稍后重试，或联系表单所有者。',
      submitPending: '我们无法确认您的回复是否已保存。请稍候片刻再试。',
      signInRequired: '提交此表单需要登录。请登录后继续。',
      signInToOpen: '登录以打开此表单',
      notAccepting: '此表单目前不接受回复。',
      signIn: '登录',
      invalidSummary: '{{count}} 个字段需要注意',
      validation: {
        wholeNumber: '{{label}} 必须是整数',
        number: '{{label}} 必须是数字',
        required: '{{label}} 为必填项',
        atLeast: '{{label}} 不能小于 {{limit}}',
        atMost: '{{label}} 不能大于 {{limit}}',
        minLength_one: '{{label}} 至少需要 {{count}} 个字符',
        minLength_other: '{{label}} 至少需要 {{count}} 个字符',
        maxLength_one: '{{label}} 最多只能有 {{count}} 个字符',
        maxLength_other: '{{label}} 最多只能有 {{count}} 个字符',
        pattern: '{{label}} 不符合要求的格式',
        outOfRange: '{{label}} 超出允许的范围',
        yesNo: '{{label}} 必须为“是”或“否”',
        invalidOption: '{{label}} 的答案不是其选项之一',
        geometryPoint: '{{label}} 必须是点',
        geometryLine: '{{label}} 必须是线',
        geometryPolygon: '{{label}} 必须是面',
        geometryBounds: '{{label}} 超出有效范围（经度 -180 至 180，纬度 -90 至 90）',
      },
      draft: {
        notice: '您有此表单的未保存草稿。恢复草稿可从上次中断处继续填写。',
        restore: '恢复草稿',
        discard: '放弃草稿',
      },
      capture: {
        empty: '未设置位置',
        setLocation: '在地图上设置',
        editLocation: '在地图上编辑',
        clear: '清除',
        done: '完成',
        cancel: '取消',
        close: '关闭',
        redraw: '重绘',
        useMyLocation: '使用我的位置',
        accuracy: '±{{meters}} 米',
        gpsError: '无法获取您的位置。请重试或在地图上设置。',
        pointSet: '已设置点',
        lineSet_one: '线 · {{count}} 个顶点',
        lineSet_other: '线 · {{count}} 个顶点',
        polygonSet_one: '面 · {{count}} 个顶点',
        polygonSet_other: '面 · {{count}} 个顶点',
        instructionsPoint: '点击地图以放置一个点。',
        instructionsLine: '点击以添加点；双击结束线。',
        instructionsPolygon: '点击以添加点；双击闭合面。',
      },
      upload: {
        choose: '选择文件',
        replace: '替换',
        remove: '移除',
        uploading: '上传中…',
        progress: '{{percent}}%',
        tooLarge: '文件过大（最大 25 MB）',
        notAllowed: '不允许此文件类型',
        failed: '上传失败 — 请重试',
        noFile: '无文件',
        attachedFile: '已附加文件',
        attachedFileWithType: '已附加文件（{{ext}}）',
      },
    },
    collect: {
      title: '表单',
      loading: '正在加载表单…',
      error: '无法加载表单。',
      empty: '没有针对此地图图层的数据采集表单。',
      submit: '提交',
      successTitle: '已记录响应',
      successBody: '要素已添加到图层。',
      fillAnother: '再填一个',
      backToList: '返回表单',
    },
    target: {
      heading: '发布目标',
      engine: '数据源',
      server: '连接',
      noServers: '未找到连接。请在“设置 → 服务器”中添加。',
      managedDatabase: 'Gisify 云数据库',
      managedHint: '此表单的图层将在您的 Gisify 托管云数据库中创建。',
      mode: '提交的数据保存到哪里？',
      newTable: '创建新图层',
      existingLayer: '使用现有图层',
      layer: '图层',
      noLayers: '此连接未找到图层。',
      geometryLocked: '几何类型跟随目标图层。',
      lockedHint: '发布后无法更改发布目标。',
      editableLayersOnly: '仅列出您可以编辑的图层。',
      layerWriteForbidden: '您需要此图层的编辑权限，才能将表单回复收集到其中。',
      layerNotEditable: '此图层的编辑功能已关闭。请联系管理员开启，或选择其他图层。',
      columnMapping: '将字段映射到列',
      mapColumnFor: '“{{field}}”的列',
      auditColumns: '向图层添加 giscenter_* 归因列',
      auditColumnsHint: '在 GIS 图层中记录每个要素的提交者。',
      engineTag: {
        postgresql: 'PostgreSQL',
        arcgis_online: 'ArcGIS Online',
        arcgis_enterprise: 'ArcGIS Enterprise',
        geoserver: 'GeoServer',
      },
      geoserverExistingOnly: 'GeoServer 表单提交到现有图层。',
      schemaLoading: '正在加载图层字段…',
      schemaError: '无法加载图层结构。',
      schemaReady: '目标图层有 {{count}} 个可用字段',
      schemaReady_other: '目标图层有 {{count}} 个可用字段',
      save: '保存目标',
      cancel: '取消',
    },
    publish: {
      publish: '发布',
      republish: '重新发布',
      publishing: '发布中…',
      published: '已发布',
      setTargetFirst: '请先选择发布目标',
      confirmAuditTitle: '添加归因列？',
      confirmAuditBody: '这将向目标图层添加 {{count}} 个 giscenter_* 列。',
      confirm: '添加列并发布',
      openForm: '打开表单',
      copyLink: '复制链接',
      copied: '已复制',
      publishError: '发布失败',
    },
    share: {
      title: '分享表单',
      tabLink: '链接',
      tabQr: '二维码',
      tabEmbed: '嵌入',
      tabAccess: '访问',
      linkLabel: '表单链接',
      copy: '复制',
      copied: '已复制',
      qrHint: '扫码即可在手机上打开表单。',
      qrDownload: '下载二维码',
      embedLabel: '嵌入代码',
      embedHint: '将此代码粘贴到网页中以嵌入表单。',
      embedPublicOnly: '嵌入的表单仅适用于公开表单。访客无法在嵌入内容中登录。',
      accessHint: {
        owner: '只有您可以打开此链接',
        organization: '已登录的组织成员',
        groups: '所选群组的成员',
        public: '任何拥有链接的人',
      },
      changeAccess: '更改访问权限',
      accessLevel: '谁可以访问',
      allowAnonymous: '允许匿名提交',
      anonymousHint: '只有公开表单才能接受匿名提交。',
      save: '保存',
      saving: '保存中…',
      saveError: '无法更新共享设置',
      groupsLabel: '与群组共享',
      groupsEmpty: '暂无可用群组。请先在“设置”中创建群组。',
      groupsRequired: '请至少选择一个群组。',
    },
  },
  alerts: {
    // Flat keys for the robot_alerts dashboard element (Slice 6). Nested keys
    // below are Slice 5's; `empty` stays the {title,body} object.
    sos: {
      title: '紧急情况',
      missedCount_one: '{{count}} 个未接紧急情况',
      missedCount_other: '{{count}} 个未接紧急情况',
      missedAgo: '未接 · {{when}}',
      missedHint: '这些紧急情况未能及时应答，仍未处理——请逐一回拨或忽略。',
      callBack: '回拨',
      dismiss: '忽略',
      handledElsewhere: '{{label}} 已在别处应答。',
      callBusy: '未发起通话——另一个紧急通话正在进行中。',
      unknownDevice: '未知设备',
      waiting_one: '还有 {{count}} 个紧急情况等待处理',
      waiting_other: '还有 {{count}} 个紧急情况等待处理',
      accept: '接受',
      acceptAndCall: '接受并通话',
      decline: '拒绝',
      failed: '无法记录您的答复。请重试。',
      call: {
        title: '紧急通话',
        with: '正在呼叫 {{name}}',
        dismiss: '关闭',
        starting: '正在准备您的麦克风…',
        ringing: '正在呼叫头盔…',
        connected: '已接通',
        idle: '',
        mute: '静音',
        unmute: '取消静音',
        muted: '您的麦克风已关闭',
        callAction: '呼叫',
        callName: '呼叫 {{name}}',
        unanswered: '该头盔上次通话未接听。',
        retryUnanswered: '此头盔未接听上一次通话。要再次呼叫 {{name}} 吗？',
        busy: '已有另一通通话正在进行。',
        micDevice: '麦克风',
        micDefault: '系统默认',
        settings: '通话设置',
        micLevel: '音量',
        micGain: '麦克风增益',
        micSilent: '您的麦克风没有声音——佩戴者听不到您。请检查系统设置中的输入设备。',
        hangUp: '挂断',
        ended: {
          hung_up: '通话已结束。',
          idle: '通话已超时。',
          max: '通话已达时长上限。',
        },
        failed: {
          unanswered: '头盔未应答，可能不支持通话。',
          mic_denied: '麦克风权限被拒绝。请允许后重试。',
          mic_failed: '无法打开您的麦克风。',
          mic_unavailable: '没有可用的麦克风。',
          no_broker_ack: '服务器从未确认此通话，可能未配置通话功能。',
          offline: '该头盔未连接。',
          channel_lost: '与头盔的连接已断开。',
          connection_lost: '通话已中断。',
          publish_failed: '您的麦克风无法接入通话。',
          media_failed: '无法接收佩戴者的音频。',
          media_timeout: '始终未收到佩戴者的音频。对方可能也听不到您。',
          call_gone: '通话已经结束。',
          calls_unavailable: '此部署不支持通话。',
          calls_not_configured: '此部署尚未配置通话功能，请联系管理员。',
          device_unidentified: '头盔尚未完成连接，请稍后重试。',
          not_prepared: '通话未建立，请重试。',
          forbidden_role: '您的账号无法发起通话。请联系管理员。',
          rejected: '通话被拒绝。',
          failed: '无法发起通话。',
        },
      },
    },
    log: {
      summary: '{{open}} 条未处理 · {{entries}} 条记录',
      pictures_one: '{{count}} 张图片',
      pictures_other: '{{count}} 张图片',
      pictureTaken: '已拍照',
      pictureTimeHint: '图片到达服务器的时间。设备不会报告快门按下的时间。',
      viewPicture: '查看图片',
      pictureUnavailable: '无法加载此图片',
      timedOut: '已停止上报',
      missed: '未接',
      timedOutHint: '该警报已超过五分钟未再上报，因此不再打断操作。它仍处于未处理状态。',
      repeatsSince: '自 {{time}} 起 {{count}} 次',
      showRepeats: '显示全部',
      hideRepeats: '隐藏重复',
      earlier_one: '另有 {{count}} 次更早的发生未列出',
      earlier_other: '另有 {{count}} 次更早的发生未列出',
      showOnMap: '在地图上显示',
      noLocation: '无位置',
      locationOfLatest: '此警报最近一次发生的位置',
      helmet: '头盔',
      tracker: '定位器',
      truncated: '显示最新 {{shown}} 条，共 {{total}} 条',
      serverCap: '服务器仅保留最新的 {{count}} 条警报和图片；更早的不会列出。',
      loadFailed: '无法加载警报历史。',
      retry: '重试',
    },
    status: {
      acknowledged: '已确认',
      resolved: '已解决',
    },
    paletteLabel: '机器人警报',
    paletteDescription: '未处理的机器人警报收件箱',
    scopeFleet: '整个机群',
    scopeRobot: '单个机器人',
    ack: '确认',
    resolve: '解决',
    filtered: '已筛选',
    empty: {
      title: '暂无警报',
      body: '警报和图片到达时将显示在此处。',
    },
    actions: {
      enroll: '录入',
      clearAll: '清除地图标记',
    },
    clearAll: {
      confirmTitle: '清除所有地图标记？',
      confirmBody: '解决此范围内所有未处理的警报以移除其地图标记 — 包括此处未列出的警报。本日志中的记录不会被删除。',
      confirmCta: '清除标记',
      cancel: '取消',
    },
    errors: {
      clearAllFailed: '无法清除警报，请重试。',
    },
    bell: {
      open: '打开警报',
    },
    drawer: {
      title: '机器人警报',
      close: '关闭',
    },
  },
  deviceList: {
    loading: '正在加载设备…',
    selectDevice: '选择设备',
    tick: '勾选',
    tickGroup: '勾选此分组中的所有设备',
    ticked: '已勾选 {{count}} 个',
    clearTicks: '清除',
    otherDevices: '其他设备',
    unnamedGroup: '未命名分组',
    groupEmpty: '此分组中没有可用设备',
    empty: {
      title: '暂无设备',
      body: '注册到您机队的设备将显示在此处。',
    },
    emptyChosen: {
      title: '所选设备均不可用',
      body: '请在此元素的设置中选择要显示的设备。',
    },
  },
  helmetWall: {
    lightOn: '开灯',
    lightOff: '关灯',
    torchHint: '打开或关闭头盔照明灯',
    laserOn: '开激光',
    laserOff: '关激光',
    laserHint: '打开或关闭头盔激光指示器',
    dblclickFocus: '双击以聚焦',
    dblclickGrid: '双击返回网格',
    fromList: '设备列表中已勾选',
    photo: '拍照',
    record: '录像',
    stopRecording: '停止录像',
    focus: '聚焦',
    unfocus: '网格',
    stopLive: '停止直播',
    startLive: '开始直播',
    removeHint: '将此头盔移出墙面',
    paused: '已停止实时画面。点击“开始直播”重新观看。',
    mbps: '{{mbps}} Mbit/s',
    bulk: {
      selectAll: '全选',
      selected: '已选 {{count}} 个',
      photo: '拍照',
      recordStart: '开始录像',
      recordStop: '停止录像',
      liveStart: '开始直播',
      liveStop: '停止直播',
      clear: '清除',
      result: {
        queued: '排队中',
        sent: '已发送',
        photo: '已收到照片',
        recording: '录像中',
        stopped: '已停止',
        live: '直播中',
        unconfirmed: '未确认',
        offline: '离线',
        refused: '被拒绝（{{code}}）',
        notSent: '未发送',
      },
    },
    selectTile: '选择 {{name}}',
    missing: '此头盔已不再注册。',
    offline: '离线 — 头盔重新连接后视频将开始。',
    preview: '编辑器中已暂停实时视频。',
    onCall: '通话中 — 通话结束后摄像头将恢复。',
    privacy: '隐私模式 — 佩戴者已暂停摄像头。',
    count: '{{shown}} 个中 {{online}} 个在线',
    layout: '布局',
    add: '添加头盔',
    noHelmets: '此组织尚未注册任何头盔。',
    empty: '此墙面上没有头盔。使用“添加头盔”将其加回。',
    badge: {
      fall: '跌倒',
      electric: '触电风险',
      alarm: '警报',
      unanswered: '未处理 — 请在警报列表中确认或解决',
      sos: 'SOS',
      worn: '已佩戴',
      notWorn: '未佩戴',
      rec: '录像中',
      onCall: '通话中',
      privacy: '隐私',
    },
  },
  tracker: {
    register: {
      open: '注册定位器',
      title: '注册定位器',
      close: '关闭',
      name: '名称',
      imei: 'IMEI',
      server: 'PostGIS 服务器',
      selectServer: '选择服务器…',
      model: '型号（可选）',
      sendPeriod: '发送周期（秒）',
      cancel: '取消',
      submit: '注册',
      submitting: '正在注册…',
      success: '定位器已注册：{{name}}',
      settingsIntro: '在 Teltonika Configurator 中打开 GPRS → Server settings，输入以下值并保存到设备：',
      done: '完成',
      errors: {
        nameRequired: '请输入此定位器的名称。',
        imeiInvalid: 'IMEI 必须恰好为 15 位数字。',
        serverRequired: '请选择存储位置的 PostGIS 服务器。',
        sendPeriodInvalid: '发送周期必须是 10 到 86400 之间的整数秒。',
        failed: '注册失败。请重试。',
      },
      settings: {
        domain: '服务器域名',
        port: '端口',
        protocol: '协议',
        dataProtocol: '数据协议',
        serverConfirmation: '服务器确认',
        unknownHost: '此部署未配置',
      },
    },
    status: {
      recordedAt: '最后记录',
      receivedAt: '接收时间',
      presenceLabel: '在线状态',
      presence: {
        online: '在线',
        stale: '失联',
        offline: '离线',
      },
      lastSeen: '最后在线',
      battery: '电量',
      charging: '充电',
      yes: '是',
      no: '否',
      batteryMv: '电池电压',
      gnssStatus: 'GNSS',
      gnss: {
        off: '关闭',
        fix: '已定位',
        noFix: '未定位',
        sleep: '休眠',
      },
      satellites: '卫星数',
      hdop: 'HDOP',
      speed: '速度',
      heading: '航向',
      movement: '运动',
      moving: '移动中',
      stationary: '静止',
      gsmSignal: 'GSM 信号',
      temperature: '温度',
      operator: '运营商',
      sections: {
        status: '状态',
        power: '电源',
        gnss: 'GNSS',
        device: '设备',
      },
      empty: '自页面打开以来此定位器尚无报告。设备发送下一条记录时将显示。',
      selectPrompt: '在此仪表板上选择一个定位器以查看其状态。',
      pickPrompt: '请在此元素的设置中选择一个定位器。',
    },
    track: {
      title: '轨迹',
      start: '起点',
      end: '终点',
      clear: '清除',
      loading: '正在加载轨迹…',
      error: '无法加载轨迹。',
      empty: '此时间段内没有位置。',
      points: '{{count}} 个点',
      truncated: '最近 {{count}} 个点（已达上限，未显示更早的点）',
      preset: {
        '1h': '1小时',
        '6h': '6小时',
        '24h': '24小时',
        '7d': '7天',
      },
    },
    config: {
      title: '定位器状态',
      tracker: '定位器',
      select: '选择定位器…',
      missing: '所选定位器不在机队名单中（已移除或仍在加载）。',
      follow: '跟随机器人选择',
      followHint: '在机队仪表板上，选择设备将显示该设备，而不是上面选择的定位器。关闭时，此磁贴始终显示上面的定位器。',
    },
  },
  geocoding: {
    title: 'Geocoding',
    steps: { source: 'Select Source', fields: 'Map Fields', options: 'Options', review: 'Review' },
    providers: { nominatim: 'Nominatim (OpenStreetMap)', arcgis: 'ArcGIS World Geocoding' },
    status: { processing: 'Processing', completed: 'Completed', failed: 'Failed' },
    wizard: {
      uploadPrompt: '点击或拖拽文件上传',
      uploadHint: '支持的格式：CSV、TXT、Excel (.xlsx)',
      reading: '正在上传并读取文件…',
      fileLoaded: '文件已加载：{{rows}} 行，{{columns}} 列',
      fileLoadedUnknownRows: '文件已加载：{{columns}} 列（文件过大，无法预先统计行数）',
      fileLoadedEstimatedRows: '文件已加载：约 {{rows}} 行（估算值），{{columns}} 列',
      rowsEstimated: '约 {{rows}} 行（估算值）',
      rowsUnknown: '未统计',
      stop: '停止',
      stopping: '正在停止…',
      stopFailed: '停止运行失败',
      stoppedTitle: '已在第 {{processed}} 行停止，共 {{total}} 行',
      stoppedBody: '目前已完成的行会保留。未使用的积分已退还。',
      resume: '继续',
      exportPartial: '导出部分结果',
      delete: '删除',
      deleteTitle: '删除此次运行？',
      deleteBody: '这将删除此次运行及其已地理编码的行，且无法撤销。',
      deleteFailed: '删除运行失败',
      resumeUnsupported: '此次运行是在停止和继续功能出现之前启动的，因此无法继续。请导出已完成的部分，或重新开始。',
      resumeNoCredits: '积分不足，无法继续此次运行。请充值后重试。',
      resumeFailed: '继续运行失败',
      addressFormat: '地址格式',
      modeConcatenate: '简单拼接',
      modeStructured: '结构化查询',
      selectColumns: '选择要组合的列（按顺序）',
      selectColumnsHelp: '各列将以逗号连接组成地址',
      addColumn: '添加',
      moveUp: '将 {{column}} 上移',
      moveDown: '将 {{column}} 下移',
      removeColumn: '移除 {{column}}',
      suffixLabel: '地址后缀（可选）',
      suffixHelp: "添加到每个地址，例如 'Malaysia' 或 'Kedah, Malaysia'",
      suffixPlaceholder: '例如：Malaysia',
      addressPreview: '地址预览',
      noPreview: '无可用预览',
      expectedRegionLabel: '预期地区/州属（可选）',
      expectedRegionHelp: '来自其他地区的结果将被标记为失败。',
      expectedRegionPlaceholder: '例如：Kedah、Selangor、Johor',
      previewFailed: '无法读取已上传的文件。',
      previewUnavailable: '我们无法读取此文件的列，因此暂时没有可映射的内容。文件已安全上传 — 请重试。',
      retryPreview: '重新读取文件',
      legacyXlsUnsupported:
        '不支持旧版 Excel 文件 (.xls)。请在 Excel 中打开该文件并另存为 .xlsx 或 CSV，然后重新上传。',
    },
    regeocode: {
      inheritedGatesHelp: '沿用上一轮的预期地区及其边界（如有）。清空此字段即可在本轮取消地区校验。',
    },
  },
  digitize: {
    edit: {
      reshape: '重塑几何形状',
      undo: '撤销',
      redo: '重做',
      delete: '删除',
      save: '保存',
      reload: '重新加载',
      noFields: '没有可编辑的字段。',
      selectLayer: '选择可编辑图层以开始编辑。',
      clickFeature: '点击地图上的要素以编辑。',
      conflict: '此要素已被他人修改。请重新加载以获取最新版本后再保存。',
      loadFailed: '加载要素失败。',
      openFailed: '无法打开此可编辑图层。它可能已被删除，或您处于离线状态。',
      saveFailed: '保存要素失败。',
      deleteFailed: '删除要素失败。',
    },
    create: {
      title: '新建可编辑图层',
      namePlaceholder: '图层名称',
      descriptionPlaceholder: '描述（可选）',
      geometryType: '几何类型',
      geometryPoint: '点',
      geometryLine: '线',
      geometryPolygon: '面',
      fields: '字段',
      fieldNamePlaceholder: '字段名称',
      fieldType: '字段类型',
      requiredShort: '必填',
      requiredAria: '必填字段',
      removeField: '移除字段',
      addField: '添加字段',
      managedHint: '此图层将在您的 Gisify 托管云数据库中创建。',
      targetServer: '目标服务器',
      selectServer: '选择服务器…',
      serverHint: '新图层只能在 PostgreSQL 或 ArcGIS 服务器上创建。',
      cancel: '取消',
      createButton: '创建图层',
      nameRequired: '名称为必填项',
      createFailed: '创建图层失败。请重试。',
      duplicateFields: '字段名称必须唯一。',
      reservedFields: '以下字段名称为保留名称，不能使用：{{names}}',
      close: '关闭',
      newFeature: '新要素',
      saveFeature: '保存要素',
    },
    schema: {
      title: '编辑结构',
      editSchema: '编辑结构',
      addField: '添加字段',
      saveSchema: '保存结构',
      saving: '保存中…',
      cancel: '取消',
      unsupportedTarget: '仅 PostgreSQL 和 ArcGIS 图层支持结构编辑。',
      notEditable: '该图层不是可编辑的数字化图层。',
      uniqueNames: '字段名称必须唯一。',
      reusedRemovedName: '同一次编辑中不能重新使用已删除的字段名称。请改为重命名。',
      conflictReload: '该要素已被他人修改。请重新加载后重试。',
    },
  },
  library: {
    editing: {
      heading: '编辑',
      features: '编辑要素',
      schema: '编辑结构',
      on: '开',
      off: '关',
      freezeNote: '启用编辑后，此图层将锁定到当前服务器和数据表，直到关闭编辑。',
      adminOnly: '只有管理员可以更改这些设置。',
      saveError: '无法更改编辑设置',
      auditColumns: {
        note: '此数据表没有归属列，因此编辑仅记录在审计日志中。你可以将它们添加到表中：',
        add: '添加归属列',
      },
    },
    replaceConfirm: {
      titleForms: '替换有表单向其收集数据的图层？',
      title: '替换此图层的数据？',
      formsIntro_one: '有 {{count}} 个表单将回复收集到此图层：',
      formsIntro_other: '有 {{count}} 个表单将回复收集到此图层：',
      formsListLabel: '向此图层收集数据的表单',
      moreForms_one: '还有 {{count}} 个表单',
      moreForms_other: '还有 {{count}} 个表单',
      opensInNewTab: '（在新标签页中打开）',
      consequencesHeading: '如果替换此图层',
      rowsDeleted: '这些表单收集的每一行都将被删除，并由新数据取代。表单仍会列出这些回复，但它们指向的行已不存在。',
      missingColumn: '如果新数据缺少某个表单字段映射的列，该表单的每次提交都会失败，直到修复表单或图层。',
      dataReplaced: '图层的当前数据将被删除，并由新数据取代。',
      columnsHeading: '列的变更',
      columnsAdded: '新增：{{columns}}',
      columnsRemoved: '移除：{{columns}}',
      columnsRetyped: '类型变更：{{columns}}',
      geometryChanged: '几何从 {{from}} 变为 {{to}}',
      geometryNone: '无',
      layersAdded: '新增图层：{{layers}}',
      layersRemoved: '移除图层：{{layers}}',
      noColumnChanges: '列没有变化',
      styleHeading: '样式',
      styleColumnsRemoved: '图层样式使用了新数据中没有的列：{{columns}}。这些样式规则将不再匹配。',
      featuresHeading: '要素',
      featureCount: '{{before}} → {{after}}',
      featureCountUnknown: '未知',
      acknowledge: '我了解图层的当前数据将被替换',
      cancel: '取消',
      confirm: '替换数据',
      error: '无法替换该图层。',
    },
    replace: {
      button: '替换数据…',
      disabled: {
        linked: '此图层指向的数据并非由 Gisify 创建。',
        typeNotReplaceable: '此类图层的数据无法替换。',
        missingSource: '此图层发布于支持替换之前——请重新发布一次以启用替换。',
        cloudEngine: '在 Gisify Cloud 工作区中，此服务器上的图层不支持替换。',
      },
      title: '替换数据：{{name}}',
      intro: '选择包含新数据的文件。图层保留其 ID、名称、共享和样式；其数据行将被替换。',
      accepted: '此图层接受的文件：',
      sameFormat: '此图层由 {{format}} 文件发布，因此只能用 {{format}} 文件替换其数据。',
      fileTypes: {
        csv: 'CSV',
        geojson: 'GeoJSON',
        shapefile: 'Shapefile（.zip）',
        geopackage: 'GeoPackage（.gpkg）',
      },
      dropzone: '点击选择文件，或将文件拖到此处',
      chosen: '已选文件：{{name}}',
      refused: {
        gdb: 'File Geodatabase 不能替换图层数据。请先将其导出为 GeoPackage 或 Shapefile。',
        multiShapefile: '此 zip 包含多个 Shapefile。替换需要仅包含一个 Shapefile 的 zip。',
        wrongType: '不能用该类型的文件替换此图层。',
        unreadable: '无法读取文件：{{reason}}',
      },
      csvCoordinates: '请选择纬度和经度列：图层的每一行都需要位置。',
      gpkgTable: 'GeoPackage 数据表',
      gpkgTableHint: '文件中包含新数据的数据表。',
      gpkgOneTable: 'GeoPackage 必须只包含一个数据表：整个文件将替换该图层。',
      gpkgTables: 'GeoPackage 数据表（每行一个）',
      gpkgTablesHint:
        '请列出两个或更多数据表。组中某个图层发布时所用的数据表将替换该图层。新数据表会添加图层；数据表缺失的图层将被移除。',
      gpkgTablesChooseFile: '选择 GeoPackage 以查看其数据表',
      gpkgTablesReading: '正在读取文件中的数据表…',
      gpkgTablesInFile: '此文件中的数据表：{{tables}}',
      gpkgTablesNone: '此 GeoPackage 不包含要素数据表。',
      gpkgTablesUnreadable: '无法列出此文件中的数据表。请逐行输入。',
      groupLoading: '正在加载组中的图层…',
      groupLoadFailed: '无法加载组中的图层。',
      groupNotPostgres: '只有存储在 PostgreSQL 中的图层组才能替换数据。',
      check: '检查文件',
      cancel: '取消',
      close: '关闭',
      retry: '重试',
      checking: '正在检查您的文件…',
      checkingHint: '尚未做任何更改。Gisify 正在将文件与图层进行比较。',
      stale: '自检查以来，图层的表单或列已发生变化。正在重新检查…',
      staleRechecked: '已重新检查：请查看以下更改。',
      replacing: '正在替换数据…',
      replacingHint: '您可以关闭此窗口，替换会继续进行。',
      inBackground: '正在替换数据…完成后此页面会自动更新。',
      done: '图层已更新',
      doneHint: '图层保留其 ID、共享和样式。其数据、范围和要素数量均已更新。',
      featuresLabel: '要素',
      statusUnknown: '无法读取替换状态。它可能仍在运行；请稍后重新加载图层。',
      errors: {
        linkedLayer: '此图层指向的数据并非由 Gisify 创建。请在其来源处替换。',
        notSupported: '此文件不能替换此图层的数据。',
        missingSource: '此图层发布于支持替换之前——请重新发布一次以启用替换。',
        generic: '出现问题，请重试。',
      },
    },
  },
  planning,
} as const
